{
  "nav": {
    "home": "Inicio",
    "about": "Acerca de"
  },
  "topbar": {
    "toggleNavigation": "Alternar navegación",
    "search": "Buscar",
    "openAiChat": "Abrir chat de IA",
    "switchToEnglish": "Cambiar a inglés",
    "switchToSpanish": "Cambiar a español"
  },
  "aiChat": {
    "label": "Chat de IA",
    "comingSoon": "El chat de IA estará disponible pronto"
  },
  "home": {
    "heading": "future-client",
    "paragraph1": "future-client es el nuevo hogar de la experiencia de proveedores y escuelas de Presence Learning: una reconstrucción desde cero diseñada para reemplazar edu-clients pantalla por pantalla, en lugar de todo a la vez.",
    "paragraph2": "Cada elemento que ves aquí, desde la navegación hasta el tema visual, está construido sobre nuestra biblioteca de componentes compartida, para que la aplicación se vea y se comporte de manera consistente con el resto de la plataforma Presence desde el primer día.",
    "paragraph3": "Esto todavía está en una etapa temprana: la mayor parte de lo que eventualmente vivirá aquí aún no se ha construido. Vuelve a revisar a medida que se traslade más de la experiencia."
  },
  "about": {
    "heading": "Acerca de",
    "paragraph1": "Este proyecto existe para darle al equipo de ingeniería de Presence Learning una base moderna y bien probada sobre la cual construir, en lugar de seguir extendiendo una base de código antigua que se ha vuelto más difícil de modificar con seguridad con el tiempo.",
    "paragraph2": "Priorizamos la accesibilidad, el rendimiento y la observabilidad desde el primer commit, de modo que el estándar de calidad para cada nueva pantalla se establece antes de que la pantalla misma exista.",
    "paragraph3": "La migración ocurrirá de forma incremental, un portal y un flujo de trabajo a la vez, para que los usuarios experimenten un flujo constante de mejoras en lugar de una transición grande y riesgosa."
  }
}
